import React, { FC, useEffect }     from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table }                    from "semantic-ui-react";
import GetCustomerRecords           from "../../../../application/usecase/record/customer/GetCustomerRecords";
import Customer                     from "../../../../domain/customer/Customer";
import CustomerRecords              from "../../../../domain/record/customer/CustomerRecords";
import { ResKaState }               from "../../../../index";
import BottomSection                from "../../common/layout/BottomSection";
import ListTotalCount               from "../../common/layout/ListTotalCount";
import ListPagination               from "../../common/ListPagination";
import CustomerRecordDeleteButton   from "./CustomerRecordDeleteButton";
import CustomerRecordEditButton     from "./CustomerRecordEditButton";

const CustomerRecordList: FC = () => {
  const customer: Customer = useSelector((state: ResKaState) => state.customer);
  const customerRecords: CustomerRecords = useSelector((state: ResKaState) => state.customerRecords);
  const getCustomerRecords: GetCustomerRecords = new GetCustomerRecords(useDispatch());
  useEffect(() => {
    getCustomerRecords.execute(customer.id, customerRecords.pagination.current);
  }, []);

  if (customerRecords.isEmpty()) {
    return (
      <>
        <p>記録情報が作成されていません。</p>
      </>
    );
  }

  return (
    <>
      <ListTotalCount>{ customerRecords.count.toString() }</ListTotalCount>
      <Table
        striped
        definition
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell collapsing/>
            <Table.HeaderCell>作成済みの記録</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            customerRecords.toList().map(customerRecord => (
              <Table.Row>
                <Table.Cell>{ customerRecord.date.asText() }</Table.Cell>
                <Table.Cell>
                  <CustomerRecordEditButton customerRecord={ customerRecord }/>
                  <CustomerRecordDeleteButton customer={ customer } customerRecord={ customerRecord }/>
                </Table.Cell>
              </Table.Row>
            ))
          }
        </Table.Body>
      </Table>

      <BottomSection>
        <ListPagination
          currentPage={ customerRecords.pagination.current }
          totalPage={ customerRecords.pagination.total }
          onChangePage={ currentPage => getCustomerRecords.execute(customer.id, currentPage) }
        />
      </BottomSection>
    </>
  );
};

export default CustomerRecordList;
